import types from '../types';

const initialState = {
  sampleUpdated: false,
  sample: undefined,
  dimensions: undefined,
  loading: false,
  sampleTheme: undefined,
  error: null,
  updateError: null,
  sampleDimensionMoved: false,
  sampleMoved: false,
};

const surveySample = (state = initialState, action) => {
  switch (action.type) {
    case types.reducerTypes.SURVEY_SAMPLE_DIMENSION_GET_PENDING: {
      return {
        ...state,
        sample: undefined,
        dimensions: undefined,
        sampleTheme: undefined,
        loading: true,
        error: null,
      };
    }
    case types.reducerTypes.SURVEY_SAMPLE_DIMENSION_GET_SUCCESS: {
      return {
        ...state,
        sample: action.payload.sample,
        dimensions: action.payload.dimensions,
        sampleTheme: action.payload.sampleTheme,
        loading: false,
        error: null,
      };
    }
    case types.reducerTypes.SURVEY_SAMPLE_DIMENSION_GET_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.reducerTypes.SURVEY_SAMPLE_DIMENSION_UPDATED: {
      return {
        ...state,
        sampleUpdated: false,
        loading: true,
        updateError: null,
      };
    }
    case types.reducerTypes.SURVEY_SAMPLE_DIMENSION_UPDATE_PENDING: {
      return {
        ...state,
        sampleUpdated: false,
        loading: true,
        updateError: null,
      };
    }
    case types.reducerTypes.SURVEY_SAMPLE_DIMENSION_UPDATE_SUCCESS: {
      return {
        ...state,
        sampleUpdated: true,
        loading: false,
        updateError: null,
      };
    }
    case types.reducerTypes.SURVEY_SAMPLE_DIMENSION_UPDATE_ERROR: {
      return {
        ...state,
        updateError: action.payload,
        loading: false,
      };
    }

    case types.reducerTypes.MOVE_SAMPLE_DIMENSION_TO_SECTION_PENDING: {
      return {
        ...state,
        sampleDimensionMoved: false,
        loading: true,
        updateError: null,
      };
    }
    case types.reducerTypes.MOVE_SAMPLE_DIMENSION_TO_SECTION_SUCCESS: {
      return {
        ...state,
        sampleDimensionMoved: true,
        loading: false,
        updateError: null,
      };
    }
    case types.reducerTypes.MOVE_SAMPLE_DIMENSION_TO_SECTION_ERROR: {
      return {
        ...state,
        updateError: action.payload,
        loading: false,
      };
    }
    case types.reducerTypes.MOVE_SAMPLE_ON_SECTION_PENDING: {
      return {
        ...state,
        sampleMoved: false,
        loading: true,
        updateError: null,
      };
    }
    case types.reducerTypes.MOVE_SAMPLE_ON_SECTION_SUCCESS: {
      return {
        ...state,
        sampleMoved: true,
        loading: false,
        updateError: null,
      };
    }
    case types.reducerTypes.MOVE_SAMPLE_ON_SECTION_ERROR: {
      return {
        ...state,
        sampleMoved: false,
        updateError: action.payload,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default surveySample;
